//lazy load
import LazyLoad from "vanilla-lazyload";
var lazyLoadInstance = new LazyLoad({
	// Your custom settings go here
	threshold:200, //pixel offset for loading images
});
